import { formSchema } from '../Form/schemas';
import { createListApiSchema } from '../General/schemas';
import { groupSchema } from '../Group/schemas';
import { typeSchema } from '../Type/schemas';
import { userSchema } from '../User/schemas';
import { zoneSchema } from '../Zone/schemas';
import { projectSchema } from '../Project/schemas';
import z from 'zod';

export const eventSchema = z
	.object({
		_id: z.string(),
		id: z.string(),
		workforceJobId: z.string().optional(),
		name: z.string(),
		typeId: z.string().optional(),
		description: z.string(),
		startTime: z.coerce.date(),
		finishTime: z.coerce.date(),
		startTimeActual: z.coerce.date(),
		finishTimeActual: z.coerce.date(),
		childGroups: z.array(z.any()),
		requirements: z.array(
			z.object({
				key: z.string(),
				issues: z.array(z.string()).optional(),
				name: z.string(),
				status: z.enum(['pending', 'inReview', 'accepted', 'expired', 'expiryWarning']),
				expiryDate: z.coerce.date(),
				timestamp: z.coerce.date(),
				data: z.any(),
			}),
		),
		status: z.enum(['pending', 'inReview', 'accepted', 'expired', 'expiryWarning', 'exception']),
		exception: z
			.object({
				isException: z.boolean(),
				reason: z.string().optional(),
				initiatedAt: z.coerce.date().optional(),
				acceptReason: z.string().optional(),
				acceptedAt: z.coerce.date().optional(),
			})
			.optional(),
		eventData: z.any(),
		enforceTiming: z.boolean().optional(),
		allowMinutesPre: z.number().optional(),
		allowMinutesPost: z.number().optional(),
		source: z.enum(['calendar', 'nineID']).optional(),
		externalId: z.string().optional(),
		archived: z.boolean().optional(),
		siteId: z.string().optional(),
		userIds: z.array(z.string()).optional(),
		adminIds: z.array(z.string()).optional(),
		hostIds: z.array(z.string()).optional(),
		groupIds: z.array(z.string()).optional(),
		allGroupIdsFlat: z.array(z.string()).optional(),
		currentGroupIdsFlat: z.array(z.string()).optional(),
		zoneIds: z.array(z.string()),
		projectId: z.string().optional(),
		parentEventId: z.string().optional(),
		isPresetPlanned: z.boolean().optional(),
		keywords: z.string(),
		readOnly: z.boolean().optional(),
		code: z.string().optional(),
		automaticReviewReasons: z.array(z.string()).optional().nullable(),
		markedForReview: z.array(z.string()).optional().nullable(),
		type: z.lazy(() => typeSchema).optional(),
		zones: z.array(z.lazy(() => zoneSchema)).optional(),
		admins: z.array(z.lazy(() => userSchema)).optional(),
		hosts: z.array(z.lazy(() => userSchema)).optional(),
		groups: z.array(z.lazy(() => groupSchema)).optional(),
		flatGroups: z.array(z.lazy(() => groupSchema)).optional(),
		users: z.array(z.lazy(() => userSchema)).optional(),
		project: z.lazy(() => projectSchema).optional(),
		parentEvent: z.lazy(() => eventSchema).optional(),
		createdAt: z.coerce.date(),
		updatedAt: z.coerce.date(),
		Form: z.lazy(() => formSchema).optional(),
	})
	.describe('Event');

// For now there's no difference between the event and calendar event schemas, but we'll keep them separated
// in order to make sure we don't get caught in incorrectly extending the event schema with calendar event properties.
export const calendarEventSchema = eventSchema;

export const eventsApiResponseSchema = createListApiSchema(eventSchema).describe('Events');
